import React from 'react';
import Card from '@jbhi-fi/lanyard-ui/components/Card';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { styles } from './Callout.css';
import { ContentfulImage, ContentfulImageProps } from '../ContentfulImage/ContentfulImage';
import { ContentfulRichText } from '@jbhi-fi/apis/src/contentful/types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export type CalloutProps = {
  heading: string;
  body?: ContentfulRichText;
  leftAnchorImage?: ContentfulImageProps;
  secondaryImage?: ContentfulImageProps;
};

// Function to render an image with given source and style
const renderImage = (imgProps: ContentfulImageProps, style?: any) => {
  return <ContentfulImage className={style} fillParent={false} isProgressive={false} {...imgProps} />;
};

//CalloutBlock component
export const Callout = ({ heading, leftAnchorImage, body, secondaryImage }: CalloutProps) => {
  const hasSecImg = Boolean(secondaryImage);

  return (
    <Card className={styles.calloutCardContainer} shadow={0}>
      <div className={styles.calloutContainer}>
        <div className={styles.calloutContent({ hasSecImg })}>
          {leftAnchorImage ? <div>{renderImage(leftAnchorImage, styles.calloutLeftAnchorImage)}</div> : null}
          <div>
            <CalloutFont as="h3" className={styles.calloutHeading}>
              {heading}
            </CalloutFont>
            {body ? <div className={styles.calloutDescription}>{documentToReactComponents(body)}</div> : null}
          </div>
        </div>
        {secondaryImage ? (
          <div className={styles.calloutSecImgSection}>{renderImage(secondaryImage, styles.calloutSecImage)}</div>
        ) : null}
      </div>
    </Card>
  );
};
